import { Button, SearchIcon, Stack } from '@fukuri-admins/ui/common';
import { TextInputField } from '@fukuri-admins/ui/common/Form/TextInputField';
import styles from './styles.module.scss';

type Props = {
  /** 利用企業名 Input の現在値 */
  clientNameValue: string;
  /** 契約プラン名 Input の現在値 */
  contractPlanNameValue: string;
  /** 利用企業名 Input 変更時のコールバック */
  onClientNameChange: (value: string) => void;
  /** 契約プラン名 Input 変更時のコールバック */
  onContractPlanNameChange: (value: string) => void;
  /** 検索ボタン押下時のコールバック */
  onSearch: () => void;
  /** 利用企業名 Input の × ボタン押下時のコールバック */
  onClientNameClear: () => void;
  /** 契約プラン名 Input の × ボタン押下時のコールバック */
  onContractPlanNameClear: () => void;
};

/**
 * 企業契約期間一覧 検索バー
 *
 * - 制御コンポーネント。各 value / onChange / onSearch / onClientNameClear / onContractPlanNameClear を外から受け取る純粋な Presentation
 * - client_name パラメータで利用企業名を部分一致検索する
 * - contract_plan_name パラメータで契約プラン名を部分一致検索する
 * - 各 Input の × ボタンは個別のクリアハンドラを持つ（片方をクリアしてももう片方は消えない）
 */
export const SearchForm: React.FC<Props> = ({
  clientNameValue,
  contractPlanNameValue,
  onClientNameChange,
  onContractPlanNameChange,
  onSearch,
  onClientNameClear,
  onContractPlanNameClear,
}) => (
  <Stack direction='row' alignItems='end' gap={8}>
    <div className={styles.inputWrapper}>
      <TextInputField
        fieldWrapperProps={{
          htmlFor: 'client-contract-list-search-client-name',
          labelText: '利用企業名',
        }}
        textInput={{
          placeholder: '利用企業名を入力',
          startIcon: <SearchIcon size='sm' />,
          value: clientNameValue,
          onChange: e => onClientNameChange(e.target.value),
          onClear: onClientNameClear,
        }}
      />
    </div>
    <div className={styles.inputWrapper}>
      <TextInputField
        fieldWrapperProps={{
          htmlFor: 'client-contract-list-search-contract-plan-name',
          labelText: 'プラン名',
        }}
        textInput={{
          placeholder: 'プラン名を検索',
          startIcon: <SearchIcon size='sm' />,
          value: contractPlanNameValue,
          onChange: e => onContractPlanNameChange(e.target.value),
          onClear: onContractPlanNameClear,
        }}
      />
    </div>
    <Button variant='secondary' size='md' onClick={onSearch}>
      検索
    </Button>
  </Stack>
);
